import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import { disableForOptions } from './constants'
import * as Styles from './styles'

const DisableInstantConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const { t } = useTranslation()

  const hasError = errors.some(e => e.type === errorTypes.actionDisableForEmpty)

  return (
    <Styles.Container id={errorTypes.actionDisableForEmpty} error={hasError}>
      <Text type="bodyMBold">{t('Deshabilitar para')}</Text>
      <Styles.CheckboxesContainer>
        {disableForOptions.map(option => (
          <Checkbox
            key={option.value}
            label={t(option.label)}
            checked={config[option.value] || false}
            onChange={e => onChangeConfig({ [option.value]: e.target.checked })}
            disabled={disabled}
            error={hasError}
          />
        ))}
      </Styles.CheckboxesContainer>
    </Styles.Container>
  )
}

export default DisableInstantConfig
